import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    title: {
        id: 'modal.no_cards_topup_modal.title',
        defaultMessage: "You don't have any active cards to top up",
    },
    currencyTitle: {
        id: 'modal.no_cards_topup_modal.title_currency',
        defaultMessage: "You don't have any active {currency} cards to top up",
    },
    ok: {
        id: 'modal.no_cards_topup_modal.ok',
        defaultMessage: 'OK',
    },
})
